import ClientExceptionRequestDto from "./dtos/ClientExceptionRequestDto";
import { coreAgent } from "../../app/api/agent";

const baseUrl = "log/";

export const logClentException = (dto: ClientExceptionRequestDto) =>
  coreAgent.postRequest<void>(baseUrl, dto);
